export const INDUSTRY_ANALYSIS_METERING_HOOK = "IndustryAnalysisMetering";
export const MARKET_ANALYSIS_HOOK = "MarketAnalysis";
export const HELP_TOOLTIP_WIDTH = 230;
export const DISABLED_TOOLTIP = "segments.page.comparison.convert.into.industry.tooltip.disabled";
export const DISABLED_TOOLTIP_SHARED = "segments.page.comparison.convert.into.industry.tooltip.disabled.shared";
